import { ReactNode } from "react";

interface InfoRowProps {
  label: string;
  value?: ReactNode;
}

export function InfoRow({ label, value }: InfoRowProps) {
  return (
    <div className="space-y-1">
      <span className="text-[10px] font-bold text-neutral-400 uppercase tracking-widest block">{label}</span>
      <span className="text-sm font-bold text-neutral-800 whitespace-pre-line block">{value ?? "—"}</span>
    </div>
  );
}

